import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Gift, Camera, PackageCheck, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Does this order owe the customer a launch gift? */
export const giftSummary = (o) => {
  const first30 = !!o.first30_rank;
  const share = !!o.gifts?.share;
  return { first30, share, owed: first30 || share, packed: !!o.gifts?.packed };
};

const chip = (on, cls) => `inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-mono-d text-[8px] uppercase tracking-[0.15em] ${on ? cls : "bg-[#f3f2ec] text-[#5f5e5a]"}`;

/** Gift badges + toggles shown in the order row. */
export const GiftControls = ({ order, headers, onChange }) => {
  const [busy, setBusy] = useState(null);
  const g = giftSummary(order);
  const sid = order.session_id;
  const set = async (field, value) => {
    setBusy(field);
    try {
      const r = await axios.patch(`${API}/admin/orders/${sid}/gifts`, { [field]: value }, { headers });
      onChange(r.data);
      toast.success(field === "share" ? (value ? "Share gift noted — add it when packing" : "Share gift removed") : value ? "Gift marked as packed" : "Gift unmarked");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not update gift.");
    } finally {
      setBusy(null);
    }
  };
  return (
    <div data-testid={`gifts-${sid}`} className="flex flex-wrap items-center gap-1.5">
      {g.first30 && <span data-testid={`gift-first30-${sid}`} className={chip(true, "bg-[#0a0a0b] text-white")}><Gift size={9} /> First 30 · #{order.first30_rank}</span>}
      <button data-testid={`gift-share-toggle-${sid}`} onClick={() => set("share", !g.share)} disabled={busy === "share"} title="Customer shared their purchase on social media" className={`${chip(g.share, "bg-[#ff2a85] text-white")} hover:opacity-80 transition-opacity`}>
        {busy === "share" ? <Loader2 size={9} className="animate-spin" /> : <Camera size={9} />} {g.share ? "Share gift" : "+ Share gift"}
      </button>
      {g.owed && (
        <button data-testid={`gift-packed-toggle-${sid}`} onClick={() => set("packed", !g.packed)} disabled={busy === "packed"} className={`${chip(g.packed, "bg-[#16a34a] text-white")} ${!g.packed ? "ring-1 ring-[#ff2a85]/60 text-[#ff2a85]" : ""} hover:opacity-80 transition-opacity`}>
          {busy === "packed" ? <Loader2 size={9} className="animate-spin" /> : <PackageCheck size={9} />} {g.packed ? "Gift packed" : "Gift to pack"}
        </button>
      )}
    </div>
  );
};
